import { render, staticRenderFns } from "./ImportaProposta.vue?vue&type=template&id=31dec507&scoped=true&"
import script from "./ImportaProposta.vue?vue&type=script&lang=js&"
export * from "./ImportaProposta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dec507",
  null
  
)

export default component.exports